import {svgIconWrapper} from '../svg-icon-wrapper';

import EyeRegular from './eye-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <EyeRegular {...validProps} />;
}

SvgComponent.iconName = 'eyeRegular';

export const EyeRegularIcon = svgIconWrapper(SvgComponent);
